import React, { useMemo } from 'react';

import { Select, SelectProps } from '@mantine/core';
import { SelectItem } from '@mantine/core/lib/Select/types';
import { CANADA_PROVINCES_TERRITORIES, UK_COUNTIES, USA_STATES } from 'localization/country';
import { localeData } from 'localization/localization-data';
import { Country, CountryEnum } from 'types/enums';

type SelectComponentProps = React.ComponentProps<typeof Select> & any;
type ByCountryProps = Partial<Record<Country, Partial<SelectComponentProps>>>;

interface RegionSelectProps extends Omit<SelectProps, 'data'> {
  country: Country;
  byCountryProps?: ByCountryProps;
}

const RegionSelect = ({ country, byCountryProps, ...selectProps }: RegionSelectProps): JSX.Element => {
  const regionData: SelectItem[] = useMemo(() => {
    if (country === CountryEnum.USA) {
      return USA_STATES;
    }
    if (country === CountryEnum.CANADA) {
      return CANADA_PROVINCES_TERRITORIES;
    }
    if (country === CountryEnum.UK) {
      return UK_COUNTIES;
    }
    return [];
  }, [country]);

  const regionLabel = localeData[country].copy.address.regionLabel;
  const placeholder = localeData[country].copy.address.regionPlaceholder;

  const countrySpecificProps = byCountryProps?.[country] ?? {};

  return (
    <Select
      label={regionLabel}
      data={regionData}
      searchable
      placeholder={placeholder}
      maxDropdownHeight={120}
      nothingFound='Not found'
      filter={(value, item: { label: string; value: string }) =>
        item.label.toLowerCase().includes(value.toLowerCase().trim()) ||
        item.value.toLowerCase().includes(value.toLowerCase().trim())
      }
      {...selectProps}
      {...countrySpecificProps}
    />
  );
};

export default RegionSelect;
